import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Subscribe() {
  const formRef = useScrollAnimation();
  
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('email', email.trim());
      const res = await fetch('https://readdy.ai/api/form/d6kppoc6fojmejgaiod0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="py-20 sm:py-24" style={{ background: '#f9f6ef' }}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={formRef}
          className="animate-scale-up rounded-2xl p-8 sm:p-12 text-center shadow-sm"
          style={{ background: '#ffffff', border: '1px solid #f0e0b0' }}
        >
          <div
            className="w-14 h-14 flex items-center justify-center rounded-full mx-auto mb-6"
            style={{ background: 'linear-gradient(135deg, #B8860B, #F5D76E)' }}
          >
            <i className="ri-gift-line text-2xl" style={{ color: '#000000' }}></i>
          </div>

          <p className="text-xs font-bold tracking-[0.3em] uppercase mb-3" style={{ color: '#C8102E' }}>
            Newsletter
          </p>

          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold mb-3" style={{ color: '#000000' }}>
            Subscribe &amp; Save 10%
          </h2>

          <div className="w-12 h-1 mx-auto mb-5 rounded-full" style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)' }} />

          {submitted ? (
            <div className="py-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full mx-auto mb-4"
                style={{ background: 'linear-gradient(135deg, #B8860B, #F5D76E)' }}>
                <i className="ri-check-line text-2xl text-black"></i>
              </div>
              <p className="text-base font-bold mb-1" style={{ color: '#000000' }}>Welcome to the Legacy community!</p>
              <p className="text-sm" style={{ color: '#666666' }}>
                Your 10% discount is on its way to your inbox. Check your email — and if you don't see it, look in your Promotions or Junk folder.
              </p>
            </div>
          ) : (
            <>
              <p className="text-base mb-8" style={{ color: '#666666' }}>
                Get <strong style={{ color: '#B8860B' }}>10% off your first session</strong> plus weekly tips on nutrition, mindset, and transformation delivered straight to your inbox.
              </p>
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="max-w-md mx-auto"
              >
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Your email address"
                    className="flex-1 px-4 py-3 rounded-lg focus:outline-none text-sm"
                    style={{ background: '#fafafa', border: '1px solid #d4b86a', color: '#333333' }}
                  />
                  <button
                    type="submit"
                    disabled={submitting}
                    className="px-8 py-3 font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                    style={{ background: submitting ? '#aaa' : 'linear-gradient(90deg, #B8860B, #F5D76E)', color: '#000000' }}
                  >
                    {submitting ? 'Signing Up...' : 'Sign Me Up'}
                  </button>
                </div>
                {error && (
                  <p className="text-xs mt-2 text-center" style={{ color: '#C8102E' }}>{error}</p>
                )}
                <p className="text-xs mt-4" style={{ color: '#aaaaaa' }}>
                  No spam, ever. Unsubscribe at any time.
                </p>
              </form>
            </>
          )}
        </div>
      </div>
    </section>
  );
}